import { createTheme, responsiveFontSizes, alpha } from '@mui/material/styles';
// Combined themeJson content directly into this file

export const buildTheme = (mode) => {
    const themeJson = {
        colorSchemes: {
            light: {
                palette: {
                    text: {
                        primary: 'rgba(0, 0, 0, 0.87)',
                        secondary: 'rgba(0, 0, 0, 0.6)',
                        disabled: 'rgba(0, 0, 0, 0.38)',
                        _states: {
                            hover: 'rgba(0, 0, 0, 0.04)',
                            selected: 'rgba(0, 0, 0, 0.08)',
                            focus: 'rgba(0, 0, 0, 0.12)',
                            focusVisible: 'rgba(0, 0, 0, 0.3)',
                        },
                    },
                    primary: {
                        main: '#1870eb',
                        dark: '#1959b1',
                        light: '#297cef',
                        contrastText: '#ffffff',
                        _states: {
                            hover: 'rgba(14, 79, 171, 0.04)',
                            selected: 'rgba(14, 79, 171, 0.08)',
                            focus: 'rgba(14, 79, 171, 0.12)',
                            focusVisible: 'rgba(14, 79, 171, 0.3)',
                            outlinedBorder: 'rgba(14, 79, 171, 0.5)',
                        },
                    },
                    secondary: {
                        main: '#5c5d6a',
                        dark: '#474858',
                        light: '#747692',
                        contrastText: '#ffffff',
                        _states: {
                            hover: 'rgba(100, 101, 113, 0.04)',
                            selected: 'rgba(100, 101, 113, 0.08)',
                            focus: 'rgba(100, 101, 113, 0.12)',
                            focusVisible: 'rgba(100, 101, 113, 0.3)',
                            outlinedBorder: 'rgba(100, 101, 113, 0.5)',
                        },
                    },
                    action: {
                        active: 'rgba(0, 0, 0, 0.56)',
                        hover: 'rgba(0, 0, 0, 0.04)',
                        selected: 'rgba(0, 0, 0, 0.08)',
                        focus: 'rgba(0, 0, 0, 0.12)',
                        disabled: 'rgba(0, 0, 0, 0.38)',
                        disabledBackground: 'rgba(0, 0, 0, 0.12)',
                    },
                    error: {
                        main: '#d32f2f',
                        dark: '#c62828',
                        light: '#ef5350',
                        contrastText: '#ffffff',
                        _states: {
                            hover: 'rgba(211, 47, 47, 0.04)',
                            selected: 'rgba(211, 47, 47, 0.08)',
                            focusVisible: 'rgba(211, 47, 47, 0.3)',
                            outlinedBorder: 'rgba(211, 47, 47, 0.5)',
                        },
                    },
                    warning: {
                        main: '#ef6c00',
                        dark: '#e65100',
                        light: '#ff9800',
                        contrastText: '#ffffff',
                        _states: {
                            hover: 'rgba(239, 108, 0, 0.04)',
                            selected: 'rgba(239, 108, 0, 0.08)',
                            focusVisible: 'rgba(239, 108, 0, 0.3)',
                            outlinedBorder: 'rgba(239, 108, 0, 0.5)',
                        },
                    },
                    info: {
                        main: '#03a9f4',
                        dark: '#0194d7',
                        light: '#0fb4fe',
                        contrastText: '#ffffff',
                        _states: {
                            hover: 'rgba(2, 136, 209, 0.04)',
                            selected: 'rgba(2, 136, 209, 0.08)',
                            focusVisible: 'rgba(2, 136, 209, 0.3)',
                            outlinedBorder: 'rgba(2, 136, 209, 0.5)',
                        },
                    },
                    success: {
                        main: '#23a35a',
                        dark: '#0a973f',
                        light: '#09c851',
                        contrastText: '#ffffff',
                        _states: {
                            hover: 'rgba(10, 151, 63, 0.04)',
                            selected: 'rgba(10, 151, 63, 0.08)',
                            focusVisible: 'rgba(10, 151, 63, 0.3)',
                            outlinedBorder: 'rgba(10, 151, 63, 0.5)',
                        },
                    },
                    common: {
                        black_states: {
                            main: '#000000',
                            hover: 'rgba(0, 0, 0, 0.04)',
                            selected: 'rgba(0, 0, 0, 0.08)',
                            focus: 'rgba(0, 0, 0, 0.12)',
                            focusVisible: 'rgba(0, 0, 0, 0.3)',
                            outlinedBorder: 'rgba(0, 0, 0, 0.4)',
                        },
                        white_states: {
                            main: '#ffffff',
                            hover: 'rgba(255, 255, 255, 0.04)',
                            selected: 'rgba(255, 255, 255, 0.08)',
                            focus: 'rgba(255, 255, 255, 0.12)',
                            focusVisible: 'rgba(255, 255, 255, 0.3)',
                            outlinedBorder: 'rgba(255, 255, 255, 0.4)',
                        },
                    },
                    background: {
                        default: '#F6F6F6',
                        'paper-elevation-0': '#ffffff',
                        'paper-elevation-1': '#ffffff',
                        'paper-elevation-2': '#ffffff',
                        'paper-elevation-3': '#ffffff',
                        'paper-elevation-4': '#ffffff',
                        'paper-elevation-5': '#ffffff',
                        'paper-elevation-6': '#F6F8FA',
                        'paper-elevation-7': '#ffffff',
                        'paper-elevation-8': '#ffffff',
                        'paper-elevation-9': '#ffffff',
                        'paper-elevation-10': '#ffffff',
                        'paper-elevation-11': '#ffffff',
                        'paper-elevation-12': '#ffffff',
                        'paper-elevation-13': '#ffffff',
                        'paper-elevation-14': '#ffffff',
                        'paper-elevation-15': '#ffffff',
                        'paper-elevation-16': '#ffffff',
                        'paper-elevation-17': '#ffffff',
                        'paper-elevation-18': '#ffffff',
                        'paper-elevation-19': '#ffffff',
                        'paper-elevation-20': '#ffffff',
                        'paper-elevation-21': '#ffffff',
                        'paper-elevation-22': '#ffffff',
                        'paper-elevation-23': '#ffffff',
                        'paper-elevation-24': '#ffffff',
                    },
                    divider: 'rgba(0, 0, 0, 0.06)',
                    elevation: {
                        outlined: '#e0e0e0',
                    },
                    _components: {
                        avatar: {
                            fill: '#bdbdbd',
                        },
                        input: {
                            standard: {
                                enabledBorder: 'rgba(0, 0, 0, 0.12)',
                                hoverBorder: '#000000',
                            },
                            filled: {
                                enabledFill: 'rgba(0, 0, 0, 0.06)',
                                hoverFill: 'rgba(0, 0, 0, 0.09)',
                            },
                            outlined: {
                                enabledBorder: 'rgba(0, 0, 0, 0.23)',
                                hoverBorder: '#000000',
                            },
                        },
                        switch: {
                            knobFillEnabled: '#fafafa',
                            slideFill: '#000000',
                            knowFillDisabled: '#f5f5f5',
                        },
                        rating: {
                            enabledBorder: 'rgba(0, 0, 0, 0.23)',
                            activeFill: '#ffb400',
                        },
                        snackbar: {
                            fill: '#262626',
                        },
                        chip: {
                            defaultCloseFill: '#000000',
                            defaultHoverFill: 'rgba(0, 0, 0, 0.12)',
                            defaultEnabledBorder: '#bdbdbd',
                            defaultFocusFill: 'rgba(0, 0, 0, 0.2)',
                        },
                        tooltip: {
                            fill: 'rgba(97, 97, 97, 0.9)',
                        },
                        backdrop: {
                            fill: 'rgba(0, 0, 0, 0.5)',
                        },
                        appBar: {
                            defaultFill: '#1959B1',
                        },
                        breadcrumbs: {
                            collapseFill: '#f5f5f5',
                        },
                        alert: {
                            error: {
                                color: '#5f2120',
                                background: '#fdeded',
                            },
                            warning: {
                                color: '#663c00',
                                background: '#fff4e5',
                            },
                            info: {
                                color: '#014361',
                                background: '#e5f6fd',
                            },
                            success: {
                                color: '#1e4620',
                                background: '#edf7ed',
                            },
                        },
                        stepper: {
                            connector: '#bdbdbd',
                        },
                        navigation: {
                            hover: '#004b95',
                            active: '#297cef',
                            header: '#acccf8',
                            backgroundColor: '#003f7d',
                            topNavBackground: 'linear-gradient(90deg, #003F7D 0%, #002B55 100%)',
                            scrollbarColor: ' #1a4e88 #133e7c',
                        },
                    },
                    _native: {
                        'scrollbar-bg': '#eeeeee',
                    },
                    icon: {
                        default: '#ffffff',
                        secondary: '#4f4f4f',
                    },
                    selector: {
                        default: '#8ca5c2',
                        primary: 'rgba(255,255,255,0.12)',
                    },
                },
                shadows: [
                    'none',
                    '0px 2px 1px -1px rgba(0, 0, 0, 0.05), 0px 1px 1px 0px rgba(0, 0, 0, 0.05), 0px 0px 3px 0px rgba(0, 0, 0, 0.05)',
                    '0px 3px 1px -2px rgba(0, 0, 0, 0.05), 0px 2px 2px 0px rgba(0, 0, 0, 0.05), 0px 1px 5px 0px rgba(0, 0, 0, 0.05)',
                    '0px 3px 3px -2px rgba(0, 0, 0, 0.05), 0px 3px 4px 0px rgba(0, 0, 0, 0.05), 0px 1px 8px 0px rgba(0, 0, 0, 0.05)',
                    '0px 2px 4px -1px rgba(0, 0, 0, 0.05), 0px 4px 5px 0px rgba(0, 0, 0, 0.05), 0px 1px 10px 0px rgba(0, 0, 0, 0.05)',
                    '0px 3px 5px -1px rgba(0, 0, 0, 0.05), 0px 5px 8px 0px rgba(0, 0, 0, 0.05), 0px 1px 14px 0px rgba(0, 0, 0, 0.05)',
                    '0px 3px 5px -1px rgba(0, 0, 0, 0.05), 0px 6px 10px 0px rgba(0, 0, 0, 0.05), 0px 1px 18px 0px rgba(0, 0, 0, 0.05)',
                    '0px 4px 5px -2px rgba(0, 0, 0, 0.05), 0px 7px 10px 1px rgba(0, 0, 0, 0.05), 0px 2px 16px 1px rgba(0, 0, 0, 0.05)',
                    '0px 5px 5px -3px rgba(0, 0, 0, 0.05), 0px 8px 10px 1px rgba(0, 0, 0, 0.05), 0px 3px 14px 2px rgba(0, 0, 0, 0.05)',
                    '0px 5px 6px -3px rgba(0, 0, 0, 0.05), 0px 9px 12px 1px rgba(0, 0, 0, 0.05), 0px 3px 16px 2px rgba(0, 0, 0, 0.05)',
                    '0px 6px 6px -3px rgba(0, 0, 0, 0.05), 0px 10px 14px 1px rgba(0, 0, 0, 0.05), 0px 4px 18px 3px rgba(0, 0, 0, 0.05)',
                    '0px 6px 7px -4px rgba(0, 0, 0, 0.05), 0px 11px 15px 1px rgba(0, 0, 0, 0.05), 0px 4px 20px 3px rgba(0, 0, 0, 0.05)',
                    '0px 7px 8px -4px rgba(0, 0, 0, 0.05), 0px 12px 17px 2px rgba(0, 0, 0, 0.05), 0px 5px 22px 4px rgba(0, 0, 0, 0.05)',
                    '0px 7px 8px -4px rgba(0, 0, 0, 0.05), 0px 13px 19px 2px rgba(0, 0, 0, 0.05), 0px 5px 24px 4px rgba(0, 0, 0, 0.05)',
                    '0px 7px 9px -4px rgba(0, 0, 0, 0.05), 0px 14px 21px 2px rgba(0, 0, 0, 0.05), 0px 5px 26px 4px rgba(0, 0, 0, 0.05)',
                    '0px 8px 9px -5px rgba(0, 0, 0, 0.05), 0px 15px 22px 2px rgba(0, 0, 0, 0.05), 0px 6px 28px 5px rgba(0, 0, 0, 0.05)',
                    '0px 8px 10px -5px rgba(0, 0, 0, 0.05), 0px 16px 24px 2px rgba(0, 0, 0, 0.05), 0px 6px 30px 5px rgba(0, 0, 0, 0.05)',
                    '0px 8px 11px -5px rgba(0, 0, 0, 0.05), 0px 17px 26px 2px rgba(0, 0, 0, 0.05), 0px 6px 32px 5px rgba(0, 0, 0, 0.05)',
                    '0px 9px 11px -5px rgba(0, 0, 0, 0.05), 0px 18px 28px 2px rgba(0, 0, 0, 0.05), 0px 7px 34px 6px rgba(0, 0, 0, 0.05)',
                    '0px 9px 12px -6px rgba(0, 0, 0, 0.05), 0px 19px 29px 2px rgba(0, 0, 0, 0.05), 0px 7px 36px 6px rgba(0, 0, 0, 0.05)',
                    '0px 10px 13px -6px rgba(0, 0, 0, 0.05), 0px 20px 31px 3px rgba(0, 0, 0, 0.05), 0px 8px 38px 7px rgba(0, 0, 0, 0.05)',
                    '0px 10px 13px -6px rgba(0, 0, 0, 0.05), 0px 21px 33px 3px rgba(0, 0, 0, 0.05), 0px 8px 40px 7px rgba(0, 0, 0, 0.05)',
                    '0px 10px 14px -6px rgba(0, 0, 0, 0.05), 0px 22px 35px 3px rgba(0, 0, 0, 0.05), 0px 8px 42px 7px rgba(0, 0, 0, 0.05)',
                    '0px 11px 14px -7px rgba(0, 0, 0, 0.05), 0px 23px 36px 3px rgba(0, 0, 0, 0.05), 0px 9px 44px 8px rgba(0, 0, 0, 0.05)',
                    '0px 11px 15px -7px rgba(0, 0, 0, 0.05), 0px 24px 38px 3px rgba(0, 0, 0, 0.05), 0px 9px 46px 8px rgba(0, 0, 0, 0.05)',
                ],
            },
            dark: {
                palette: {
                    text: {
                        primary: '#ffffff',
                        secondary: 'rgba(255, 255, 255, 0.7)',
                        disabled: 'rgba(255, 255, 255, 0.38)',
                        _states: {
                            hover: 'rgba(255, 255, 255, 0.08)',
                            selected: 'rgba(255, 255, 255, 0.16)',
                            focus: 'rgba(255, 255, 255, 0.12)',
                            focusVisible: 'rgba(255, 255, 255, 0.3)',
                        },
                    },
                    primary: {
                        main: '#5d9ffc',
                        dark: '#4078c5',
                        light: '#97c2ff',
                        contrastText: 'rgba(0, 0, 0, 0.87)',
                        _states: {
                            hover: 'rgba(144, 202, 249, 0.08)',
                            selected: 'rgba(144, 202, 249, 0.16)',
                            focus: 'rgba(144, 202, 249, 0.12)',
                            focusVisible: 'rgba(144, 202, 249, 0.3)',
                            outlinedBorder: 'rgba(144, 202, 249, 0.5)',
                        },
                    },
                    secondary: {
                        main: '#a8a9b6',
                        dark: '#8d8f9c',
                        light: '#bdbed3',
                        contrastText: 'rgba(0, 0, 0, 0.87)',
                        _states: {
                            hover: 'rgba(173, 174, 185, 0.08)',
                            selected: 'rgba(173, 174, 185, 0.16)',
                            focus: 'rgba(173, 174, 185, 0.12)',
                            focusVisible: 'rgba(173, 174, 185, 0.3)',
                            outlinedBorder: 'rgba(173, 174, 185, 0.5)',
                        },
                    },
                    action: {
                        active: 'rgba(255, 255, 255, 0.56)',
                        hover: 'rgba(255, 255, 255, 0.08)',
                        selected: 'rgba(255, 255, 255, 0.16)',
                        focus: 'rgba(255, 255, 255, 0.12)',
                        disabled: 'rgba(255, 255, 255, 0.38)',
                        disabledBackground: 'rgba(255, 255, 255, 0.12)',
                    },
                    error: {
                        main: '#f44336',
                        dark: '#d32f2f',
                        light: '#e57373',
                        contrastText: '#ffffff',
                        _states: {
                            hover: 'rgba(244, 67, 54, 0.08)',
                            selected: 'rgba(244, 67, 54, 0.16)',
                            focusVisible: 'rgba(244, 67, 54, 0.3)',
                            outlinedBorder: 'rgba(244, 67, 54, 0.5)',
                        },
                    },
                    warning: {
                        main: '#ffa726',
                        dark: '#f57c00',
                        light: '#ffb74d',
                        contrastText: 'rgba(0, 0, 0, 0.87)',
                        _states: {
                            hover: 'rgba(255, 167, 38, 0.08)',
                            selected: 'rgba(255, 167, 38, 0.16)',
                            focusVisible: 'rgba(255, 167, 38, 0.3)',
                            outlinedBorder: 'rgba(255, 167, 38, 0.5)',
                        },
                    },
                    info: {
                        main: '#29b6f6',
                        dark: '#0288d1',
                        light: '#4fc3f7',
                        contrastText: 'rgba(0, 0, 0, 0.87)',
                        _states: {
                            hover: 'rgba(41, 182, 246, 0.08)',
                            selected: 'rgba(41, 182, 246, 0.16)',
                            focusVisible: 'rgba(41, 182, 246, 0.3)',
                            outlinedBorder: 'rgba(41, 182, 246, 0.5)',
                        },
                    },
                    success: {
                        main: '#66bb6a',
                        dark: '#388e3c',
                        light: '#66bb6a',
                        contrastText: 'rgba(0, 0, 0, 0.87)',
                        _states: {
                            hover: 'rgba(102, 187, 106, 0.08)',
                            selected: 'rgba(102, 187, 106, 0.16)',
                            focusVisible: 'rgba(102, 187, 106, 0.3)',
                            outlinedBorder: 'rgba(102, 187, 106, 0.5)',
                        },
                    },
                    common: {
                        black_states: {
                            main: '#000000',
                            hover: 'rgba(0, 0, 0, 0.08)',
                            selected: 'rgba(0, 0, 0, 0.16)',
                            focus: 'rgba(0, 0, 0, 0.12)',
                            focusVisible: 'rgba(0, 0, 0, 0.3)',
                            outlinedBorder: 'rgba(0, 0, 0, 0.4)',
                        },
                        white_states: {
                            main: '#ffffff',
                            hover: 'rgba(255, 255, 255, 0.08)',
                            selected: 'rgba(255, 255, 255, 0.16)',
                            focus: 'rgba(255, 255, 255, 0.12)',
                            focusVisible: 'rgba(255, 255, 255, 0.3)',
                            outlinedBorder: 'rgba(255, 255, 255, 0.4)',
                        },
                    },
                    background: {
                        default: '#121212',
                        'paper-elevation-0': '#121212',
                        'paper-elevation-1': '#1e1e1e',
                        'paper-elevation-2': '#232323',
                        'paper-elevation-3': '#252525',
                        'paper-elevation-4': '#272727',
                        'paper-elevation-5': '#2a2a2a',
                        'paper-elevation-6': '#2c2c2c',
                        'paper-elevation-7': '#2c2c2c',
                        'paper-elevation-8': '#2e2e2e',
                        'paper-elevation-9': '#2e2e2e',
                        'paper-elevation-10': '#313131',
                        'paper-elevation-11': '#313131',
                        'paper-elevation-12': '#333333',
                        'paper-elevation-13': '#333333',
                        'paper-elevation-14': '#333333',
                        'paper-elevation-15': '#333333',
                        'paper-elevation-16': '#363636',
                        'paper-elevation-17': '#363636',
                        'paper-elevation-18': '#363636',
                        'paper-elevation-19': '#363636',
                        'paper-elevation-20': '#383838',
                        'paper-elevation-21': '#383838',
                        'paper-elevation-22': '#383838',
                        'paper-elevation-23': '#383838',
                        'paper-elevation-24': '#383838',
                    },
                    divider: 'rgba(255, 255, 255, 0.06)',
                    elevation: {
                        outlined: 'rgba(255, 255, 255, 0.06)',
                    },
                    _components: {
                        avatar: {
                            fill: '#757575',
                        },
                        input: {
                            standard: {
                                enabledBorder: 'rgba(255, 255, 255, 0.12)',
                                hoverBorder: '#ffffff',
                            },
                            filled: {
                                enabledFill: 'rgba(255, 255, 255, 0.09)',
                                hoverFill: 'rgba(255, 255, 255, 0.12)',
                            },
                            outlined: {
                                enabledBorder: 'rgba(255, 255, 255, 0.23)',
                                hoverBorder: '#ffffff',
                            },
                        },
                        switch: {
                            knobFillEnabled: '#e0e0e0',
                            slideFill: 'rgba(255, 255, 255, 0.38)',
                            knowFillDisabled: '#757575',
                        },
                        rating: {
                            enabledBorder: 'rgba(255, 255, 255, 0.23)',
                            activeFill: '#ffb400',
                        },
                        snackbar: {
                            fill: '#2c2c2c',
                        },
                        chip: {
                            defaultCloseFill: '#ffffff',
                            defaultHoverFill: 'rgba(255, 255, 255, 0.12)',
                            defaultEnabledBorder: '#616161',
                            defaultFocusFill: 'rgba(255, 255, 255, 0.2)',
                        },
                        tooltip: {
                            fill: 'rgba(97, 97, 97, 0.9)',
                        },
                        backdrop: {
                            fill: 'rgba(0, 0, 0, 0.5)',
                        },
                        appBar: {
                            defaultFill: '#272727',
                        },
                        breadcrumbs: {
                            collapseFill: '#757575',
                        },
                        alert: {
                            error: {
                                color: '#f4c7c7',
                                background: '#160b0b',
                            },
                            warning: {
                                color: '#ffe2b7',
                                background: '#191207',
                            },
                            info: {
                                color: '#b8e7fb',
                                background: '#071318',
                            },
                            success: {
                                color: '#cce8cd',
                                background: '#0c130d',
                            },
                        },
                        stepper: {
                            connector: '#757575',
                        },
                        navigation: {
                            hover: '#004b95',
                            active: '#297cef',
                            header: '#acccf8',
                            backgroundColor: '#003f7d',
                            topNavBackground: 'linear-gradient(90deg, #003F7D 0%, #002B55 100%)',
                            scrollbarColor: ' #1a4e88 #133e7c',
                        },
                    },
                    _native: {
                        'scrollbar-bg': '#616161',
                    },
                    icon: {
                        default: '#4f4f4f',
                        secondary: '#ffffff',
                    },
                    selector: {
                        default: '#8ca5c2',
                        primary: 'rgba(255,255,255,0.12)',
                    },
                },

                shadows: [
                    'none',
                    '0px 2px 1px -1px rgba(0, 0, 0, 1), 0px 1px 1px 0px rgba(0, 0, 0, 1), 0px 0px 3px 0px rgba(0, 0, 0, 1)',
                    '0px 3px 1px -2px rgba(0, 0, 0, 1), 0px 2px 2px 0px rgba(0, 0, 0, 1), 0px 1px 5px 0px rgba(0, 0, 0, 1)',
                    '0px 3px 3px -2px rgba(0, 0, 0, 1), 0px 3px 4px 0px rgba(0, 0, 0, 1), 0px 1px 8px 0px rgba(0, 0, 0, 1)',
                    '0px 2px 4px -1px rgba(0, 0, 0, 1), 0px 4px 5px 0px rgba(0, 0, 0, 1), 0px 1px 10px 0px rgba(0, 0, 0, 1)',
                    '0px 3px 5px -1px rgba(0, 0, 0, 1), 0px 5px 8px 0px rgba(0, 0, 0, 1), 0px 1px 14px 0px rgba(0, 0, 0, 1)',
                    '0px 3px 5px -1px rgba(0, 0, 0, 1), 0px 6px 10px 0px rgba(0, 0, 0, 1), 0px 1px 18px 0px rgba(0, 0, 0, 1)',
                    '0px 4px 5px -2px rgba(0, 0, 0, 1), 0px 7px 10px 1px rgba(0, 0, 0, 1), 0px 2px 16px 1px rgba(0, 0, 0, 1)',
                    '0px 5px 5px -3px rgba(0, 0, 0, 1), 0px 8px 10px 1px rgba(0, 0, 0, 1), 0px 3px 14px 2px rgba(0, 0, 0, 1)',
                    '0px 5px 6px -3px rgba(0, 0, 0, 1), 0px 9px 12px 1px rgba(0, 0, 0, 1), 0px 3px 16px 2px rgba(0, 0, 0, 1)',
                    '0px 6px 6px -3px rgba(0, 0, 0, 1), 0px 10px 14px 1px rgba(0, 0, 0, 1), 0px 4px 18px 3px rgba(0, 0, 0, 1)',
                    '0px 6px 7px -4px rgba(0, 0, 0, 1), 0px 11px 15px 1px rgba(0, 0, 0, 1), 0px 4px 20px 3px rgba(0, 0, 0, 1)',
                    '0px 7px 8px -4px rgba(0, 0, 0, 1), 0px 12px 17px 2px rgba(0, 0, 0, 1), 0px 5px 22px 4px rgba(0, 0, 0, 1)',
                    '0px 7px 8px -4px rgba(0, 0, 0, 1), 0px 13px 19px 2px rgba(0, 0, 0, 1), 0px 5px 24px 4px rgba(0, 0, 0, 1)',
                    '0px 7px 9px -4px rgba(0, 0, 0, 1), 0px 14px 21px 2px rgba(0, 0, 0, 1), 0px 5px 26px 4px rgba(0, 0, 0, 1)',
                    '0px 8px 9px -5px rgba(0, 0, 0, 1), 0px 15px 22px 2px rgba(0, 0, 0, 1), 0px 6px 28px 5px rgba(0, 0, 0, 1)',
                    '0px 8px 10px -5px rgba(0, 0, 0, 1), 0px 16px 24px 2px rgba(0, 0, 0, 1), 0px 6px 30px 5px rgba(0, 0, 0, 1)',
                    '0px 8px 11px -5px rgba(0, 0, 0, 1), 0px 17px 26px 2px rgba(0, 0, 0, 1), 0px 6px 32px 5px rgba(0, 0, 0, 1)',
                    '0px 9px 11px -5px rgba(0, 0, 0, 1), 0px 18px 28px 2px rgba(0, 0, 0, 1), 0px 7px 34px 6px rgba(0, 0, 0, 1)',
                    '0px 9px 12px -6px rgba(0, 0, 0, 1), 0px 19px 29px 2px rgba(0, 0, 0, 1), 0px 7px 36px 6px rgba(0, 0, 0, 1)',
                    '0px 10px 13px -6px rgba(0, 0, 0, 1), 0px 20px 31px 3px rgba(0, 0, 0, 1), 0px 8px 38px 7px rgba(0, 0, 0, 1)',
                    '0px 10px 13px -6px rgba(0, 0, 0, 1), 0px 21px 33px 3px rgba(0, 0, 0, 1), 0px 8px 40px 7px rgba(0, 0, 0, 1)',
                    '0px 10px 14px -6px rgba(0, 0, 0, 1), 0px 22px 35px 3px rgba(0, 0, 0, 1), 0px 8px 42px 7px rgba(0, 0, 0, 1)',
                    '0px 11px 14px -7px rgba(0, 0, 0, 1), 0px 23px 36px 3px rgba(0, 0, 0, 1), 0px 9px 44px 8px rgba(0, 0, 0, 1)',
                    '0px 11px 15px -7px rgba(0, 0, 0, 1), 0px 24px 38px 3px rgba(0, 0, 0, 1), 0px 9px 46px 8px rgba(0, 0, 0, 1)',
                ],
            },
        },
        'material/colors': {
            amber: {
                50: '#fff8e1',
                100: '#ffecb3',
                200: '#ffe082',
                300: '#ffd54f',
                400: '#ffca28',
                500: '#ffc107',
                600: '#ffb300',
                700: '#ffa000',
                800: '#ff8f00',
                900: '#ff6f00',
                A100: '#ffe57f',
                A200: '#ffd740',
                A400: '#ffc400',
                A700: '#ffab00',
            },
            blue: {
                50: '#e3f2fd',
                100: '#bbdefb',
                200: '#90caf9',
                300: '#64b5f6',
                400: '#42a5f5',
                500: '#2196f3',
                600: '#1e88e5',
                700: '#1976d2',
                800: '#1565c0',
                900: '#0d47a1',
                A100: '#82b1ff',
                A200: '#448aff',
                A400: '#2979ff',
                A700: '#2962ff',
            },
            blueGrey: {
                50: '#eceff1',
                100: '#cfd8dc',
                200: '#b0bec5',
                300: '#90a4ae',
                400: '#78909c',
                500: '#607d8b',
                600: '#546e7a',
                700: '#455a64',
                800: '#37474f',
                900: '#263238',
                A100: '#cfd8dc',
                A200: '#b0bec5',
                A400: '#78909c',
                A700: '#455a64',
            },
            cyan: {
                50: '#e0f7fa',
                100: '#b2ebf2',
                200: '#80deea',
                300: '#4dd0e1',
                400: '#26c6da',
                500: '#00bcd4',
                600: '#00acc1',
                700: '#0097a7',
                800: '#00838f',
                900: '#006064',
                A100: '#84ffff',
                A200: '#18ffff',
                A400: '#00e5ff',
                A700: '#00b8d4',
            },
            deepOrange: {
                50: '#fbe9e7',
                100: '#ffccbc',
                200: '#ffab91',
                300: '#ff8a65',
                400: '#ff7043',
                500: '#ff5722',
                600: '#f4511e',
                700: '#e64a19',
                800: '#d84315',
                900: '#bf360c',
                A100: '#ff9e80',
                A200: '#ff6e40',
                A400: '#ff3d00',
                A700: '#dd2c00',
            },
            deepPurple: {
                50: '#ede7f6',
                100: '#d1c4e9',
                200: '#b39ddb',
                300: '#9575cd',
                400: '#7e57c2',
                500: '#673ab7',
                600: '#5e35b1',
                700: '#512da8',
                800: '#4527a0',
                900: '#311b92',
                A100: '#b388ff',
                A200: '#7c4dff',
                A400: '#651fff',
                A700: '#6200ea',
            },
            green: {
                50: '#e8f5e9',
                100: '#c8e6c9',
                200: '#a5d6a7',
                300: '#81c784',
                400: '#66bb6a',
                500: '#4caf50',
                600: '#43a047',
                700: '#388e3c',
                800: '#2e7d32',
                900: '#1b5e20',
                A100: '#b9f6ca',
                A200: '#69f0ae',
                A400: '#00e676',
                A700: '#00c853',
            },
            grey: {
                50: '#fafafa',
                100: '#f5f5f5',
                200: '#eeeeee',
                300: '#e0e0e0',
                400: '#bdbdbd',
                500: '#9e9e9e',
                600: '#757575',
                700: '#616161',
                800: '#424242',
                900: '#212121',
                A100: '#f5f5f5',
                A200: '#eeeeee',
                A400: '#bdbdbd',
                A700: '#616161',
            },
            indigo: {
                50: '#e8eaf6',
                100: '#c5cae9',
                200: '#9fa8da',
                300: '#7986cb',
                400: '#5c6bc0',
                500: '#3f51b5',
                600: '#3949ab',
                700: '#303f9f',
                800: '#283593',
                900: '#1a237e',
                A100: '#8c9eff',
                A200: '#536dfe',
                A400: '#3d5afe',
                A700: '#304ffe',
            },
            lightBlue: {
                50: '#e1f5fe',
                100: '#b3e5fc',
                200: '#81d4fa',
                300: '#4fc3f7',
                400: '#29b6f6',
                500: '#03a9f4',
                600: '#039be5',
                700: '#0288d1',
                800: '#0277bd',
                900: '#01579b',
                A100: '#80d8ff',
                A200: '#40c4ff',
                A400: '#00b0ff',
                A700: '#0091ea',
            },
            lightGreen: {
                50: '#f1f8e9',
                100: '#dcedc8',
                200: '#c5e1a5',
                300: '#aed581',
                400: '#8bc34a',
                500: '#8bc34a',
                600: '#7cb342',
                700: '#689f38',
                800: '#558b2f',
                900: '#33691e',
                A100: '#ccff90',
                A200: '#b2ff59',
                A400: '#76ff03',
                A700: '#64dd17',
            },
            lime: {
                50: '#f9fbe7',
                100: '#f0f4c3',
                200: '#e6ee9c',
                300: '#dce775',
                400: '#d4e157',
                500: '#cddc39',
                600: '#c0ca33',
                700: '#afb42b',
                800: '#9e9d24',
                900: '#827717',
                A100: '#f4ff81',
                A200: '#eeff41',
                A400: '#c6ff00',
                A700: '#aeea00',
            },
            orange: {
                50: '#fff3e0',
                100: '#ffe0b2',
                200: '#ffcc80',
                300: '#ffb74d',
                400: '#ffa726',
                500: '#ff9800',
                600: '#fb8c00',
                700: '#f57c00',
                800: '#ef6c00',
                900: '#e65100',
                A100: '#ffd180',
                A200: '#ffab40',
                A400: '#ff9100',
                A700: '#ff6d00',
            },
            pink: {
                50: '#fce4ec',
                100: '#f8bbd0',
                200: '#f48fb1',
                300: '#f06292',
                400: '#ec407a',
                500: '#e91e63',
                600: '#d81b60',
                700: '#c2185b',
                800: '#ad1457',
                900: '#880e4f',
                A100: '#ff80ab',
                A200: '#ff4081',
                A400: '#f50057',
                A700: '#c51162',
            },
            purple: {
                50: '#f3e5f5',
                100: '#e1bee7',
                200: '#ce93d8',
                300: '#ba68c8',
                400: '#ab47bc',
                500: '#9c27b0',
                600: '#8e24aa',
                700: '#7b1fa2',
                800: '#6a1b9a',
                900: '#4a148c',
                A100: '#ea80fc',
                A200: '#e040fb',
                A400: '#d500f9',
                A700: '#aa00ff',
            },
            red: {
                50: '#feebee',
                100: '#fecdd2',
                200: '#ef9a9a',
                300: '#e57373',
                400: '#ef5350',
                500: '#f44336',
                600: '#e53935',
                700: '#d32f2f',
                800: '#c62828',
                900: '#b71c1c',
                A100: '#ff8a80',
                A200: '#ff5252',
                A400: '#ff1744',
                A700: '#d50000',
            },
            teal: {
                50: '#e0f2f1',
                100: '#b2dfdb',
                200: '#80cbc4',
                300: '#4db6ac',
                400: '#26a69a',
                500: '#009688',
                600: '#00897b',
                700: '#00796b',
                800: '#00695c',
                900: '#004d40',
                A100: '#a7ffeb',
                A200: '#64ffda',
                A400: '#1de9b6',
                A700: '#00bfa5',
            },
            yellow: {
                50: '#fffde7',
                100: '#fff9c4',
                200: '#fff59d',
                300: '#fff176',
                400: '#ffee58',
                500: '#ffeb3b',
                600: '#fdd835',
                700: '#fbc02d',
                800: '#f9a825',
                900: '#f57f17',
                A100: '#ffff8d',
                A200: '#ffff00',
                A400: '#ffea00',
                A700: '#ffd600',
            },
        },
        textStyles: {
            typography: {
                h1: {
                    fontFamily: 'Inter',
                    fontWeight: 300,
                    fontSize: 96,
                    lineHeight: '116.7%',
                    letterSpacing: '-1.5px',
                },
                h2: {
                    fontFamily: 'Inter',
                    fontWeight: 300,
                    fontSize: 60,
                    lineHeight: '120%',
                    letterSpacing: '-0.5px',
                },
                h3: {
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: 48,
                    lineHeight: '116.7%',
                    letterSpacing: '0px',
                },
                h4: {
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: 34,
                    lineHeight: '123.5%',
                    letterSpacing: '0.25px',
                },
                h5: {
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: 20,
                    lineHeight: '133.4%',
                    letterSpacing: '0px',
                },
                h6: {
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: 20,
                    lineHeight: '160%',
                    letterSpacing: '0.15px',
                },
                body1: {
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: 16,
                    lineHeight: '150%',
                    letterSpacing: '0.15px',
                },
                body2: {
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: 14,
                    lineHeight: '143%',
                    letterSpacing: '0.17px',
                },
                subtitle1: {
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: 16,
                    lineHeight: '175%',
                    letterSpacing: '0.15px',
                },
                subtitle2: {
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: 14,
                    lineHeight: '157%',
                    letterSpacing: '0.1px',
                },
                overline: {
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: 12,
                    lineHeight: '266%',
                    letterSpacing: '1px',
                },
                caption: {
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: 12,
                    lineHeight: '166%',
                    letterSpacing: '0.4px',
                },
            },
            alert: {
                title: {
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: 16,
                    lineHeight: '150%',
                    letterSpacing: '0.15px',
                },
                description: {
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: 14,
                    lineHeight: '143%',
                    letterSpacing: '0.15px',
                },
            },
            avatar: {
                initialsLg: {
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: 20,
                    lineHeight: '20px',
                    letterSpacing: '0.14px',
                },
                initialsSm: {
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: 10,
                    lineHeight: '10px',
                    letterSpacing: '0px',
                },
                initialsMd: {
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: 12,
                    lineHeight: '12px',
                    letterSpacing: '0px',
                },
            },
            badge: {
                label: {
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: 12,
                    lineHeight: '20px',
                    letterSpacing: '0.14px',
                },
            },
            bottomNavigation: {
                activeLabel: {
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: 14,
                    lineHeight: '166%',
                    letterSpacing: '0.4px',
                },
            },
            button: {
                large: {
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: 15,
                    lineHeight: '26px',
                    letterSpacing: '0.46px',
                },
                medium: {
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: 14,
                    lineHeight: '24px',
                    letterSpacing: '0.4px',
                },
                small: {
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: 13,
                    lineHeight: '22px',
                    letterSpacing: '0.46px',
                },
            },
            chip: {
                label: {
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: 13,
                    lineHeight: '18px',
                    letterSpacing: '0.16px',
                },
            },
            datePicker: {
                currentMonth: {
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: 14,
                    lineHeight: '150%',
                    letterSpacing: '0.15px',
                },
            },
            input: {
                label: {
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: 12,
                    lineHeight: '12px',
                    letterSpacing: '0.15px',
                },
                value: {
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: 14,
                    lineHeight: '24px',
                    letterSpacing: '0.15px',
                },
                helper: {
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: 12,
                    lineHeight: '166%',
                    letterSpacing: '0.4px',
                },
            },
            list: {
                subheader: {
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: 14,
                    lineHeight: '48px',
                    letterSpacing: '0.1px',
                },
            },
            menu: {
                itemDefault: {
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: 16,
                    lineHeight: '150%',
                    letterSpacing: '0.15px',
                },
                itemDense: {
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: 14,
                    lineHeight: '24px',
                    letterSpacing: '0.17px',
                },
            },
            table: {
                header: {
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: 14,
                    lineHeight: '24px',
                    letterSpacing: '0.17px',
                },
            },
            tooltip: {
                label: {
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: 10,
                    lineHeight: '14px',
                    letterSpacing: '0px',
                },
            },
            dataGrid: {
                aggregationColumnHeaderLabel: {
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: 12,
                    lineHeight: '12px',
                    letterSpacing: '0.15px',
                },
            },
            charts: {
                group: {
                    fontFamily: 'Roboto',
                    fontWeight: 400,
                    fontSize: 12,
                    lineHeight: '166%',
                    letterSpacing: '0%',
                },
            },
        },
        breakpoints: {
            xl: '1536px',
            lg: '1200px',
            md: '900px',
            sm: '600px',
            xs: '444px',
        },
        shape: {
            borderRadius: '4px',
            none: '0px',
        },

        components: {
            MuiPaper: {
                styleOverrides: {
                    root: {
                        '&.MuiAppBar-root': {
                            background: 'linear-gradient(90deg, #003F7D 0%, #002B55 100%)',
                        },
                        '&.MuiPaper-elevation': {
                            '&.MuiPaper-elevation1': {
                                ':not(&.MuiPaper-rounded)': {
                                    borderTopLeftRadius: '0px',
                                    borderTopRightRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    borderBottomRightRadius: '0px',
                                    boxShadow: 'rgba(0, 0, 0, 0.07) 0px 0px 0px 1px;',
                                },
                                '&.MuiPaper-rounded': {
                                    borderTopLeftRadius: '4px',
                                    borderTopRightRadius: '4px',
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',
                                    boxShadow: 'rgba(0, 0, 0, 0.07) 0px 0px 0px 1px;',
                                },
                            },
                            '&.MuiPaper-elevation0': {
                                ':not(&.MuiPaper-rounded)': {
                                    borderTopLeftRadius: '0px',
                                    borderTopRightRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    borderBottomRightRadius: '0px',
                                },
                                '&.MuiPaper-rounded': {
                                    borderTopLeftRadius: '4px',
                                    borderTopRightRadius: '4px',
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',
                                },
                            },
                            '&.MuiPaper-elevation11': {
                                ':not(&.MuiPaper-rounded)': {
                                    borderTopLeftRadius: '0px',
                                    borderTopRightRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    borderBottomRightRadius: '0px',

                                    boxShadow: '0px 6px 7px rgba(0, 0, 0, 0.06), 0px 11px 15px rgba(0, 0, 0, 0.06), 0px 4px 20px rgba(0, 0, 0, 0.06)',
                                },
                                '&.MuiPaper-rounded': {
                                    borderTopLeftRadius: '4px',
                                    borderTopRightRadius: '4px',
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',

                                    boxShadow: '0px 6px 7px rgba(0, 0, 0, 0.06), 0px 11px 15px rgba(0, 0, 0, 0.06), 0px 4px 20px rgba(0, 0, 0, 0.06)',
                                },
                            },
                            '&.MuiPaper-elevation10': {
                                ':not(&.MuiPaper-rounded)': {
                                    borderTopLeftRadius: '0px',
                                    borderTopRightRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    borderBottomRightRadius: '0px',

                                    boxShadow: '0px 6px 6px rgba(0, 0, 0, 0.06), 0px 10px 14px rgba(0, 0, 0, 0.06), 0px 4px 18px rgba(0, 0, 0, 0.06)',
                                },
                                '&.MuiPaper-rounded': {
                                    borderTopLeftRadius: '4px',
                                    borderTopRightRadius: '4px',
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',

                                    boxShadow: '0px 6px 6px rgba(0, 0, 0, 0.06), 0px 10px 14px rgba(0, 0, 0, 0.06), 0px 4px 18px rgba(0, 0, 0, 0.06)',
                                },
                            },
                            '&.MuiPaper-elevation9': {
                                ':not(&.MuiPaper-rounded)': {
                                    borderTopLeftRadius: '0px',
                                    borderTopRightRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    borderBottomRightRadius: '0px',

                                    boxShadow: '0px 5px 6px rgba(0, 0, 0, 0.2), 0px 9px 12px rgba(0, 0, 0, 0.06), 0px 3px 16px rgba(0, 0, 0, 0.06)',
                                },
                                '&.MuiPaper-rounded': {
                                    borderTopLeftRadius: '4px',
                                    borderTopRightRadius: '4px',
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',

                                    boxShadow: '0px 5px 6px rgba(0, 0, 0, 0.2), 0px 9px 12px rgba(0, 0, 0, 0.06), 0px 3px 16px rgba(0, 0, 0, 0.06)',
                                },
                            },
                            '&.MuiPaper-elevation2': {
                                ':not(&.MuiPaper-rounded)': {
                                    borderTopLeftRadius: '0px',
                                    borderTopRightRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    borderBottomRightRadius: '0px',

                                    boxShadow: 'rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;',
                                },
                                '&.MuiPaper-rounded': {
                                    borderTopLeftRadius: '4px',
                                    borderTopRightRadius: '4px',
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',

                                    boxShadow: 'rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;',
                                },
                            },
                            '&.MuiPaper-elevation12': {
                                ':not(&.MuiPaper-rounded)': {
                                    borderTopLeftRadius: '0px',
                                    borderTopRightRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    borderBottomRightRadius: '0px',

                                    boxShadow: '0px 7px 8px rgba(0, 0, 0, 0.06), 0px 12px 17px rgba(0, 0, 0, 0.06), 0px 5px 22px rgba(0, 0, 0, 0.06)',
                                },
                                '&.MuiPaper-rounded': {
                                    borderTopLeftRadius: '4px',
                                    borderTopRightRadius: '4px',
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',

                                    boxShadow: '0px 7px 8px rgba(0, 0, 0, 0.06), 0px 12px 17px rgba(0, 0, 0, 0.06), 0px 5px 22px rgba(0, 0, 0, 0.06)',
                                },
                            },
                            '&.MuiPaper-elevation3': {
                                ':not(&.MuiPaper-rounded)': {
                                    borderTopLeftRadius: '0px',
                                    borderTopRightRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    borderBottomRightRadius: '0px',

                                    boxShadow: '0px 3px 3px rgba(0, 0, 0, 0.06), 0px 3px 4px rgba(0, 0, 0, 0.06), 0px 1px 8px rgba(0, 0, 0, 0.06)',
                                },
                                '&.MuiPaper-rounded': {
                                    borderTopLeftRadius: '4px',
                                    borderTopRightRadius: '4px',
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',

                                    boxShadow: '0px 3px 3px rgba(0, 0, 0, 0.06), 0px 3px 4px rgba(0, 0, 0, 0.06), 0px 1px 8px rgba(0, 0, 0, 0.06)',
                                },
                            },
                            '&.MuiPaper-elevation13': {
                                ':not(&.MuiPaper-rounded)': {
                                    borderTopLeftRadius: '0px',
                                    borderTopRightRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    borderBottomRightRadius: '0px',

                                    boxShadow: '0px 7px 8px rgba(0, 0, 0, 0.06), 0px 13px 19px rgba(0, 0, 0, 0.06), 0px 5px 24px rgba(0, 0, 0, 0.06)',
                                },
                                '&.MuiPaper-rounded': {
                                    borderTopLeftRadius: '4px',
                                    borderTopRightRadius: '4px',
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',

                                    boxShadow: '0px 7px 8px rgba(0, 0, 0, 0.06), 0px 13px 19px rgba(0, 0, 0, 0.06), 0px 5px 24px rgba(0, 0, 0, 0.06)',
                                },
                            },
                            '&.MuiPaper-elevation4': {
                                ':not(&.MuiPaper-rounded)': {
                                    borderTopLeftRadius: '0px',
                                    borderTopRightRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    borderBottomRightRadius: '0px',

                                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.06), 0px 4px 5px rgba(0, 0, 0, 0.06), 0px 1px 10px rgba(0, 0, 0, 0.06)',
                                },
                                '&.MuiPaper-rounded': {
                                    borderTopLeftRadius: '4px',
                                    borderTopRightRadius: '4px',
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',

                                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.06), 0px 4px 5px rgba(0, 0, 0, 0.06), 0px 1px 10px rgba(0, 0, 0, 0.06)',
                                },
                            },
                            '&.MuiPaper-elevation14': {
                                ':not(&.MuiPaper-rounded)': {
                                    borderTopLeftRadius: '0px',
                                    borderTopRightRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    borderBottomRightRadius: '0px',

                                    boxShadow: '0px 7px 9px rgba(0, 0, 0, 0.06), 0px 14px 21px rgba(0, 0, 0, 0.06), 0px 5px 26px rgba(0, 0, 0, 0.06)',
                                },
                                '&.MuiPaper-rounded': {
                                    borderTopLeftRadius: '4px',
                                    borderTopRightRadius: '4px',
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',

                                    boxShadow: '0px 7px 9px rgba(0, 0, 0, 0.06), 0px 14px 21px rgba(0, 0, 0, 0.06), 0px 5px 26px rgba(0, 0, 0, 0.06)',
                                },
                            },
                            '&.MuiPaper-elevation5': {
                                ':not(&.MuiPaper-rounded)': {
                                    borderTopLeftRadius: '0px',
                                    borderTopRightRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    borderBottomRightRadius: '0px',

                                    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.06), 0px 5px 8px rgba(0, 0, 0, 0.06), 0px 1px 14px rgba(0, 0, 0, 0.06)',
                                },
                                '&.MuiPaper-rounded': {
                                    borderTopLeftRadius: '4px',
                                    borderTopRightRadius: '4px',
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',

                                    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.06), 0px 5px 8px rgba(0, 0, 0, 0.06), 0px 1px 14px rgba(0, 0, 0, 0.06)',
                                },
                            },
                            '&.MuiPaper-elevation15': {
                                ':not(&.MuiPaper-rounded)': {
                                    borderTopLeftRadius: '0px',
                                    borderTopRightRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    borderBottomRightRadius: '0px',

                                    boxShadow: '0px 8px 9px rgba(0, 0, 0, 0.06), 0px 15px 22px rgba(0, 0, 0, 0.06), 0px 6px 28px rgba(0, 0, 0, 0.06)',
                                },
                                '&.MuiPaper-rounded': {
                                    borderTopLeftRadius: '4px',
                                    borderTopRightRadius: '4px',
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',

                                    boxShadow: '0px 8px 9px rgba(0, 0, 0, 0.06), 0px 15px 22px rgba(0, 0, 0, 0.06), 0px 6px 28px rgba(0, 0, 0, 0.06)',
                                },
                            },
                            '&.MuiPaper-elevation6': {
                                ':not(&.MuiPaper-rounded)': {
                                    borderTopLeftRadius: '0px',
                                    borderTopRightRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    borderBottomRightRadius: '0px',

                                    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2), 0px 6px 10px rgba(0, 0, 0, 0.06), 0px 1px 18px rgba(0, 0, 0, 0.06)',
                                },
                                '&.MuiPaper-rounded': {
                                    borderTopLeftRadius: '4px',
                                    borderTopRightRadius: '4px',
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',

                                    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2), 0px 6px 10px rgba(0, 0, 0, 0.06), 0px 1px 18px rgba(0, 0, 0, 0.06)',
                                },
                            },
                            '&.MuiPaper-elevation16': {
                                ':not(&.MuiPaper-rounded)': {
                                    borderTopLeftRadius: '0px',
                                    borderTopRightRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    borderBottomRightRadius: '0px',

                                    boxShadow:
                                        '0px 8px 10px rgba(0, 0, 0, 0.06), 0px 16px 24px rgba(0, 0, 0, 0.06), 0px 6px 30px rgba(0, 0, 0, 0.06)',
                                },
                                '&.MuiPaper-rounded': {
                                    borderTopLeftRadius: '4px',
                                    borderTopRightRadius: '4px',
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',

                                    boxShadow:
                                        '0px 8px 10px rgba(0, 0, 0, 0.06), 0px 16px 24px rgba(0, 0, 0, 0.06), 0px 6px 30px rgba(0, 0, 0, 0.06)',
                                },
                            },
                            '&.MuiPaper-elevation7': {
                                ':not(&.MuiPaper-rounded)': {
                                    borderTopLeftRadius: '0px',
                                    borderTopRightRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    borderBottomRightRadius: '0px',

                                    boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.06), 0px 7px 10px rgba(0, 0, 0, 0.06), 0px 2px 16px rgba(0, 0, 0, 0.06)',
                                },
                                '&.MuiPaper-rounded': {
                                    borderTopLeftRadius: '4px',
                                    borderTopRightRadius: '4px',
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',

                                    boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.06), 0px 7px 10px rgba(0, 0, 0, 0.06), 0px 2px 16px rgba(0, 0, 0, 0.06)',
                                },
                            },
                            '&.MuiPaper-elevation17': {
                                ':not(&.MuiPaper-rounded)': {
                                    borderTopLeftRadius: '0px',
                                    borderTopRightRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    borderBottomRightRadius: '0px',

                                    boxShadow:
                                        '0px 8px 11px rgba(0, 0, 0, 0.06), 0px 17px 26px rgba(0, 0, 0, 0.06), 0px 6px 32px rgba(0, 0, 0, 0.06)',
                                },
                                '&.MuiPaper-rounded': {
                                    borderTopLeftRadius: '4px',
                                    borderTopRightRadius: '4px',
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',

                                    boxShadow:
                                        '0px 8px 11px rgba(0, 0, 0, 0.06), 0px 17px 26px rgba(0, 0, 0, 0.06), 0px 6px 32px rgba(0, 0, 0, 0.06)',
                                },
                            },
                            '&.MuiPaper-elevation8': {
                                ':not(&.MuiPaper-rounded)': {
                                    borderTopLeftRadius: '0px',
                                    borderTopRightRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    borderBottomRightRadius: '0px',

                                    boxShadow: '0px 5px 5px rgba(0, 0, 0, 0.06), 0px 8px 10px rgba(0, 0, 0, 0.06), 0px 3px 14px rgba(0, 0, 0, 0.06)',
                                },
                                '&.MuiPaper-rounded': {
                                    borderTopLeftRadius: '4px',
                                    borderTopRightRadius: '4px',
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',

                                    boxShadow: '0px 5px 5px rgba(0, 0, 0, 0.06), 0px 8px 10px rgba(0, 0, 0, 0.06), 0px 3px 14px rgba(0, 0, 0, 0.06)',
                                },
                            },
                            '&.MuiPaper-elevation18': {
                                ':not(&.MuiPaper-rounded)': {
                                    borderTopLeftRadius: '0px',
                                    borderTopRightRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    borderBottomRightRadius: '0px',

                                    boxShadow:
                                        '0px 9px 11px rgba(0, 0, 0, 0.06), 0px 18px 28px rgba(0, 0, 0, 0.06), 0px 7px 34px rgba(0, 0, 0, 0.06)',
                                },
                                '&.MuiPaper-rounded': {
                                    borderTopLeftRadius: '4px',
                                    borderTopRightRadius: '4px',
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',

                                    boxShadow:
                                        '0px 9px 11px rgba(0, 0, 0, 0.06), 0px 18px 28px rgba(0, 0, 0, 0.06), 0px 7px 34px rgba(0, 0, 0, 0.06)',
                                },
                            },
                            '&.MuiPaper-elevation19': {
                                ':not(&.MuiPaper-rounded)': {
                                    borderTopLeftRadius: '0px',
                                    borderTopRightRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    borderBottomRightRadius: '0px',

                                    boxShadow:
                                        '0px 9px 12px rgba(0, 0, 0, 0.06), 0px 19px 29px rgba(0, 0, 0, 0.06), 0px 7px 36px rgba(0, 0, 0, 0.06)',
                                },
                                '&.MuiPaper-rounded': {
                                    borderTopLeftRadius: '4px',
                                    borderTopRightRadius: '4px',
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',

                                    boxShadow:
                                        '0px 9px 12px rgba(0, 0, 0, 0.06), 0px 19px 29px rgba(0, 0, 0, 0.06), 0px 7px 36px rgba(0, 0, 0, 0.06)',
                                },
                            },
                            '&.MuiPaper-elevation20': {
                                ':not(&.MuiPaper-rounded)': {
                                    borderTopLeftRadius: '0px',
                                    borderTopRightRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    borderBottomRightRadius: '0px',

                                    boxShadow:
                                        '0px 10px 13px rgba(0, 0, 0, 0.06), 0px 20px 31px rgba(0, 0, 0, 0.06), 0px 8px 38px rgba(0, 0, 0, 0.06)',
                                },
                                '&.MuiPaper-rounded': {
                                    borderTopLeftRadius: '4px',
                                    borderTopRightRadius: '4px',
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',

                                    boxShadow:
                                        '0px 10px 13px rgba(0, 0, 0, 0.06), 0px 20px 31px rgba(0, 0, 0, 0.06), 0px 8px 38px rgba(0, 0, 0, 0.06)',
                                },
                            },
                            '&.MuiPaper-elevation21': {
                                ':not(&.MuiPaper-rounded)': {
                                    borderTopLeftRadius: '0px',
                                    borderTopRightRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    borderBottomRightRadius: '0px',

                                    boxShadow:
                                        '0px 10px 13px rgba(0, 0, 0, 0.06), 0px 21px 33px rgba(0, 0, 0, 0.06), 0px 8px 40px rgba(0, 0, 0, 0.06)',
                                },
                                '&.MuiPaper-rounded': {
                                    borderTopLeftRadius: '4px',
                                    borderTopRightRadius: '4px',
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',

                                    boxShadow:
                                        '0px 10px 13px rgba(0, 0, 0, 0.06), 0px 21px 33px rgba(0, 0, 0, 0.06), 0px 8px 40px rgba(0, 0, 0, 0.06)',
                                },
                            },
                            '&.MuiPaper-elevation22': {
                                ':not(&.MuiPaper-rounded)': {
                                    borderTopLeftRadius: '0px',
                                    borderTopRightRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    borderBottomRightRadius: '0px',

                                    boxShadow:
                                        '0px 10px 14px rgba(0, 0, 0, 0.06), 0px 22px 35px rgba(0, 0, 0, 0.06), 0px 8px 42px rgba(0, 0, 0, 0.06)',
                                },
                                '&.MuiPaper-rounded': {
                                    borderTopLeftRadius: '4px',
                                    borderTopRightRadius: '4px',
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',

                                    boxShadow:
                                        '0px 10px 14px rgba(0, 0, 0, 0.06), 0px 22px 35px rgba(0, 0, 0, 0.06), 0px 8px 42px rgba(0, 0, 0, 0.06)',
                                },
                            },
                            '&.MuiPaper-elevation23': {
                                ':not(&.MuiPaper-rounded)': {
                                    borderTopLeftRadius: '0px',
                                    borderTopRightRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    borderBottomRightRadius: '0px',

                                    boxShadow:
                                        '0px 11px 14px rgba(0, 0, 0, 0.06), 0px 23px 36px rgba(0, 0, 0, 0.06), 0px 9px 44px rgba(0, 0, 0, 0.06)',
                                },
                                '&.MuiPaper-rounded': {
                                    borderTopLeftRadius: '4px',
                                    borderTopRightRadius: '4px',
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',

                                    boxShadow:
                                        '0px 11px 14px rgba(0, 0, 0, 0.06), 0px 23px 36px rgba(0, 0, 0, 0.06), 0px 9px 44px rgba(0, 0, 0, 0.06)',
                                },
                            },
                            '&.MuiPaper-elevation24': {
                                ':not(&.MuiPaper-rounded)': {
                                    borderTopLeftRadius: '0px',
                                    borderTopRightRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    borderBottomRightRadius: '0px',

                                    boxShadow:
                                        '0px 11px 15px rgba(0, 0, 0, 0.06), 0px 24px 38px rgba(0, 0, 0, 0.06), 0px 9px 46px rgba(0, 0, 0, 0.06)',
                                },
                                '&.MuiPaper-rounded': {
                                    borderTopLeftRadius: '4px',
                                    borderTopRightRadius: '4px',
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',

                                    boxShadow:
                                        '0px 11px 15px rgba(0, 0, 0, 0.06), 0px 24px 38px rgba(0, 0, 0, 0.06), 0px 9px 46px rgba(0, 0, 0, 0.06)',
                                },
                            },
                        },
                        '&.MuiPaper-outlined': {
                            '&.MuiPaper-elevation0': {
                                ':not(&.MuiPaper-rounded)': {
                                    borderTopLeftRadius: '0px',
                                    borderTopRightRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    borderBottomRightRadius: '0px',

                                    borderLeft: '1px solid #e0e0e0',
                                    borderRight: '1px solid #e0e0e0',
                                    borderTop: '1px solid #e0e0e0',
                                    borderBottom: '1px solid #e0e0e0',
                                },
                                '&.MuiPaper-rounded': {
                                    borderTopLeftRadius: '4px',
                                    borderTopRightRadius: '4px',
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',

                                    borderLeft: '1px solid #e0e0e0',
                                    borderRight: '1px solid #e0e0e0',
                                    borderTop: '1px solid #e0e0e0',
                                    borderBottom: '1px solid #e0e0e0',
                                },
                            },
                        },
                    },
                },
            },
            MuiSwitch: {
                styleOverrides: {
                    root: {
                        width: 46,
                        height: 24,
                        padding: 0,
                        display: 'flex',
                        '&:active': {
                            '& .MuiSwitch-thumb': {
                                width: 20,
                            },
                            '& .MuiSwitch-switchBase.Mui-checked': {
                                transform: 'translateX(22px)',
                            },
                        },
                        '& .MuiSwitch-switchBase': {
                            padding: 2,
                            '&.Mui-checked': {
                                transform: 'translateX(22px)',
                                color: '#fff',
                                '& + .MuiSwitch-track': {
                                    opacity: 1,
                                    backgroundColor: '#1870eb',
                                },
                            },
                        },
                        '& .MuiSwitch-thumb': {
                            boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
                            width: 20,
                            height: 20,
                            borderRadius: 30,
                            transition: 'width 200ms',
                        },
                        '& .MuiSwitch-track': {
                            borderRadius: 32,
                            opacity: 0.38,
                            boxSizing: 'border-box',
                            '&::before, &::after': {
                                content: '""',
                                position: 'absolute',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                width: 16,
                                height: 16,
                            },
                            '&::before': {
                                backgroundImage:
                                    'url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="%23ffffff" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>\')',
                                left: 6,
                            },
                            '&::after': {
                                backgroundImage:
                                    'url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="%23ffffff" d="M19,13H5V11H19V13Z" /></svg>\')',
                                right: 6,
                            },
                        },
                    },
                },
            },

            MuiDialogTitle: {
                styleOverrides: {
                    root: {
                        padding: '16px !important',
                        fontFamily: 'Inter',
                        fontSize: '20px',
                        letterSpacing: '0.15px',
                        fontWeight: '400',
                    },
                },
            },
            MuiDialogContent: {
                styleOverrides: {
                    root: {
                        padding: '16px !important',
                        borderTopLeftRadius: '0px',
                        borderTopRightRadius: '0px',
                        borderBottomLeftRadius: '0px',
                        borderBottomRightRadius: '0px',
                    },
                    '&.MuiDialogContent-dividers': {
                        borderTopColor: 'rgba(0, 0, 0, 0.06)',
                        borderBottomColor: 'rgba(0, 0, 0, 0.06)',
                    },
                },
            },
            MuiDialogActions: {
                styleOverrides: {
                    root: {
                        padding: '16px !important',
                        gap: '8px',

                        '& .MuiDialogActions-text': {
                            color: {
                                color: '#ffffff',
                            },
                        },
                    },
                },
            },
            MuiPickersLayout: {
                styleOverrides: {
                    root: {
                        maxWidth: '100%',
                        overflowX: 'hidden',
                    },
                },
            },
            MuiDateCalendar: {
                styleOverrides: {
                    root: {
                        maxWidth: '100%',
                        width: 'auto',
                        '@media (max-width: 320px)': {
                            width: '280px',
                        },
                    },
                },
            },
            MuiPickersCalendarHeader: {
                styleOverrides: {
                    root: {
                        maxWidth: '100%',
                        paddingLeft: '12px',
                        paddingRight: '12px',
                    },
                },
            },
            MuiDayCalendar: {
                styleOverrides: {
                    root: {
                        maxWidth: '100%',
                    },
                    header: {
                        justifyContent: 'space-around',
                    },
                    weekContainer: {
                        justifyContent: 'space-around',
                    },
                },
            },
            MuiMobileDateTimePicker: {
                defaultProps: {
                    DialogProps: {
                        PaperProps: {
                            sx: {
                                maxWidth: 'calc(100vw - 32px)',
                                margin: '16px',
                                overflowX: 'hidden',
                            },
                        },
                    },
                },
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    notchedOutline: {
                        borderWidth: '0.9px',
                        '&:hover': {
                            borderWidth: '1px !important',
                        },
                    },
                },
            },
            MuiTextField: {
                styleOverrides: {
                    root: {
                        '& .MuiOutlinedInput-root .MuiOutlinedInput-input': {
                            fontSize: '15px',
                        },
                    },
                },
            },
            MuiTooltip: {
                defaultProps: {
                    enterDelay: 100,
                    leaveDelay: 100,
                },
            },

            MuiInputBase: {
                styleOverrides: {
                    adornedEnd: {
                        paddingRight: '4px !important',
                    },
                    inputSizeSmall: {
                        fontSize: '13px !important', // Set font size to 11px for small inputs
                    },
                },
            },
            MuiTab: {
                styleOverrides: {
                    root: {
                        textTransform: 'none !important', // Ensure individual tabs are not uppercase
                    },
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        textTransform: 'none !important', // Ensure button text is not uppercase
                        '&.Mui-focusVisible': {
                            outlineOffset: '5px !important', // Set focus outline offset to 5px
                        },
                    },
                },
            },
            MuiLinearProgress: {
                styleOverrides: {
                    root: {
                        backgroundColor: mode === 'light' ? 'rgb(167, 200, 247)' : 'rgb(46, 79, 126)',
                    },
                    bar: {
                        backgroundColor: mode === 'light' ? '#1870eb' : '#5d9ffc',
                    },
                },
            },
        },
    };
    const palette = themeJson.colorSchemes[mode].palette;

    const dataGridTokens = {
        primary: palette.primary.main,
        elevation: palette.background['paper-elevation-6'],
        sortHover: mode === 'light' ? '#d6d6d6' : alpha('#d6d6d6', 0.28), // define the random value, wait the color from dark theme.
        rowAlt: mode === 'light' ? '#fafafa' : palette.grey[800], // define the random value, wait the color from dark theme.
        rowHover: mode === 'light' ? '#f5fbff' : alpha(palette.primary.light, 0.12), // define the random value, wait the color from dark theme.
    };

    const baseTheme = createTheme({
        palette: {
            mode, // Set the mode (light or dark)
            ...palette, // Apply the color scheme for the mode
            dataGrid: dataGridTokens,
        },
        components: themeJson.components,
    });

    return responsiveFontSizes(baseTheme);
};
